import { IsNotEmpty, IsString } from 'class-validator';

export class ConsultantAssigneeCandidatesQueryDto {
  @IsString()
  @IsNotEmpty()
  tenantId!: string;
}
